import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Select } from '@lyearn/ui';
import { getSelectOptionLabel } from '@/components/Form/components/Select/getOptionLabel';
import { CronFrequencyEnum } from '@/types/schema';

import { EmailDigestFrequency } from '../../../conts';
import { FrequencyComponentProps } from '../../../types';

const getOptions = (allowedFrequencies?: CronFrequencyEnum[]) => {
  if (!allowedFrequencies?.length) {
    return EmailDigestFrequency;
  }

  return EmailDigestFrequency.filter((item) => allowedFrequencies.includes(item.value));
};

const Frequency = ({
  value,
  onChange,
  disabled,
  allowedFrequencies,
  size,
}: FrequencyComponentProps) => {
  const onFrequencyChange = useCallback(
    (value: CronFrequencyEnum) => onChange({ frequency: value }),
    [onChange],
  );
  const { t } = useTranslation(['Events']);
  const options = getOptions(allowedFrequencies);

  return (
    <Select
      disableClearable
      className="w-1/2"
      disabled={disabled}
      getOptionLabel={(option) => t(`Events:RecurringSession.${getSelectOptionLabel(option)}`)}
      options={options}
      size={size ?? 'large'}
      value={value.frequency}
      onChange={onFrequencyChange}
    />
  );
};

export default Frequency;
